export function getKeyAlgorithms(withDilithium = false) {
  const algorithms = ['RSA', 'EC']

  if (withDilithium) {
    algorithms.push('DILITHIUM')
  }

  return algorithms
}
